import { render, staticRenderFns } from "./print_personnel.vue?vue&type=template&id=587843c4&scoped=true"
import script from "./print_personnel.vue?vue&type=script&lang=js"
export * from "./print_personnel.vue?vue&type=script&lang=js"
import style0 from "./print_personnel.vue?vue&type=style&index=0&id=587843c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587843c4",
  null
  
)

export default component.exports